import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CSS from './ActionBtn.scss';
const ActionButton = ({ children, onClick, className, style, disabled = false, id }) => {
    const classes = [CSS.ActionBtn, className ? className : ''];
    return (_jsx("button", { style: { ...style }, id: id ? id : undefined, className: classes.join(' '), disabled: disabled, onClick: (e) => onClick?.(e), children: children }));
};
export default ActionButton;
